import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {Hotel} from '@findhotel/sapi'
import {getSeoActiveAttributes} from 'modules/meta/selectors'
import {getListOfValues} from 'modules/search/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'

import {getHotelTopAttributes} from './getHotelTopAttributes'

interface Props {
  hotel: Pick<Hotel, 'facilities' | 'themeIds' | 'starRating' | 'guestRating'>
}

export const HotelTopAttributes: React.FC<Props> = ({hotel}) => {
  const listOfValues = useSelector(getListOfValues)
  const seoActiveAttributes = useSelector(getSeoActiveAttributes)

  const topAttributes = useMemo(() => {
    return getHotelTopAttributes(seoActiveAttributes, hotel, listOfValues)
  }, [hotel, listOfValues, seoActiveAttributes])

  if (!topAttributes.length) return null

  return (
    <div data-id="HotelTopAttributes">
      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(130px, 1fr))"
        columnGap="s200"
        rowGap="s250"
      >
        {topAttributes.map(attribute => (
          <Box
            display="flex"
            width="100%"
            alignItems="flex-start"
            justifyContent="flex-start"
            gap="s200"
            key={attribute.label}
          >
            <Icon
              size="sm"
              name={attribute.icon}
              colorPath="content.neutral.primary"
            />
            <Text variant="bodyXS" colorPath="content.neutral.primary">
              {attribute.label}
            </Text>
          </Box>
        ))}
      </Box>
    </div>
  )
}
